/**
 * List of custom nav events
 */
const navEvent = {
  CART_COUNT_CHANGE_EVENT: 'rei.gnav.cartCountChange',
};

export default navEvent;